import { render, staticRenderFns } from "./Pricelevels.vue?vue&type=template&id=bc9234b8&scoped=true&"
import script from "./Pricelevels.vue?vue&type=script&lang=js&"
export * from "./Pricelevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9234b8",
  null
  
)

export default component.exports